export default "__VITE_ASSET__BCeXFJin__"